import Vue from 'vue'
import Router from 'vue-router'
import SignIn from './views/SignIn.vue'
Vue.use(Router)

export default new Router({
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'SignIn',
			component: SignIn
		},
		{
			path: '/headpage',
			name: 'headpage',
			component: () => import('./views/Index.vue')
		},
		{
			path: '/home',
			name: 'home',
			component: () => import('./views/home.vue'),
			children: [{
					path: "/index",
					name: 'index',
					component: () => import('./views/Index.vue'),
				},
				{
					// 待报价
					path: "/saMain",
					name: 'saMain',
					component: () => import('./views/main/saMain.vue'),
				},
				{
					// 配件
					path: "/partsList",
					name: 'partsList',
					component: () => import('./views/dataManage/partsList.vue'),
				},
				{
					// 工时
					path: "/workHoursList",
					name: 'workHoursList',
					component: () => import('./views/dataManage/workHoursList.vue'),
				},

				{
					// 全车运营统计
					path: "/businessIntelligence",
					name: 'businessIntelligence',
					component: () => import('./views/vehicleInspectionAnalysis/businessIntelligence.vue'),
				},
				{
					// 全车运营统计
					path: "/dailyTestAndDeal",
					name: 'dailyTestAndDeal',
					component: () => import('./views/vehicleInspectionAnalysis/dailyTestAndDeal.vue'),
				},
				{
					// 全车运营统计
					path: "/dailyTestAndDealChart",
					name: 'dailyTestAndDealChart',
					component: () => import('./views/vehicleInspectionAnalysis/dailyTestAndDealChart.vue'),
				},



				{
					// 数据管理报表
					path: "/DataManagementReport",
					name: 'DataManagementReport',
					component: () => import('./views/menu/DataManagementReport.vue'),
				},
				{
					// 运营BI报表
					path: "/BIreport",
					name: 'BIreport',
					component: () => import('./views/menu/BIreport.vue'),
				},


				{
					// 车辆检测数据
					path: "/dossierManager",
					name: 'dossierManager',
					component: () => import('./views/DataManagementReport/dossierManager.vue'),
				},
				{
					// 检测清单导出
					path: "/testListDownload",
					name: 'testListDownload',
					component: () => import('./views/DataManagementReport/testListDownload.vue'),
				},
				{
					// 失销统计分析
					path: "/lossSale",
					name: 'lossSale',
					component: () => import('./views/DataManagementReport/lossSale.vue'),
				},
				{
					// 报告跟踪分析
					path: "/dossierRequestLogSys",
					name: 'dossierRequestLogSys',
					component: () => import('./views/DataManagementReport/dossierRequestLogSys.vue'),
				},
				{
					// 环检图片查询
					path: "/queryMediaLibraryCountInfo",
					name: 'queryMediaLibraryCountInfo',
					component: () => import('./views/pictureLibrary/queryMediaLibraryCountInfo.vue'),
				},


				{
					// 车型分析
					path: "/PowerBI3",
					name: 'PowerBI3',
					component: () => import('./views/PowerBI/PowerBI3_1.vue'),
				},
				{
					// 里程分析
					path: "/PowerBI4",
					name: 'PowerBI4',
					component: () => import('./views/PowerBI/PowerBI4_1.vue'),
				},
				{
					// 检测部位成交分析
					path: "/PowerBI6",
					name: 'PowerBI6',
					component: () => import('./views/PowerBI/PowerBI6.vue'),
				},

				{// 项目分组列表
					path: "/projectGroupManage",
					name: 'projectGroupManage',
					component: () => import('./views/projectGroupIncome/projectGroupManage.vue'),
				},
				{// 销售项目收入
					path: "/saleRegistrationManage",
					name: 'saleRegistrationManage',
					component: () => import('./views/projectGroupIncome/saleRegistrationManage.vue'),
				},
				{// 销售项目收入报表
					path: "/powerBISalesIncome",
					name: 'powerBISalesIncome',
					component: () => import('./views/projectGroupIncome/powerBISalesIncome.vue'),
				},


			]
		},
	]
})
